import { Component, OnInit } from '@angular/core';
import { DataService } from '../../data.service';
import { QueryService } from '../../@tools/query';

@Component({
    selector: 'app-news',
    templateUrl: './news.component.html',
    styleUrls: [ './news.component.scss', '../form.scss' ]
})
export class NewsComponent implements OnInit {

    news = {
        title: '',
        picture: '',
        content: '',
        url: ''
    };

    constructor(private DATA: DataService, private query: QueryService) {
        DATA.current_table = 'form_news';
    }

    ngOnInit(): void {
    }

    create() {
        this.query.post('news', this.news).then(news => {
            this.news = {
                title: '',
                picture: '',
                content: '',
                url: ''
            };
        });
    }
}
